import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileExtFilter',
    pure: true
})

export class FileExtensionFilterPipe implements PipeTransform {
    transform(items: any[], filter: string): any[] {
        if (!items || !filter || filter === "") {
            return items;
        }
        return items.filter(item => item.name.endsWith(filter));
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/file-extension-filter.pipe.ts